import { render, staticRenderFns } from "./fullAdmission.vue?vue&type=template&id=4c3c2957&scoped=true"
import script from "./fullAdmission.vue?vue&type=script&lang=js"
export * from "./fullAdmission.vue?vue&type=script&lang=js"
import style0 from "./fullAdmission.vue?vue&type=style&index=0&id=4c3c2957&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3c2957",
  null
  
)

export default component.exports